import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowUpCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 30a14 14 0 1 1 0-28 14 14 0 0 1 0 28m7.69-15.69-6.89-7A1.13 1.13 0 0 0 16 7a1.1 1.1 0 0 0-.8.31l-6.89 7a1.07 1.07 0 0 0 0 1.5 1 1 0 0 0 1.48 0L15 10.5V24a1 1 0 0 0 2 0V10.5l5.22 5.31a1 1 0 0 0 1.48 0 1.07 1.07 0 0 0-.01-1.5" />
  </svg>
);
const ForwardRef = forwardRef(IconArrowUpCircleFilledSVG);
ForwardRef.displayName = "IconArrowUpCircleFilled";
export { ForwardRef as IconArrowUpCircleFilled };
